import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Theme, Tooltip } from '@mui/material';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { colorPalette } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { prevent } from '../../../shared/utils';

const styles = ({ transitions, spacing }: Theme) => {
  const transition = transitions.create(['opacity', 'color'], {
    duration: transitions.duration.shorter,
  });

  return {
    icon: {
      color: `${colorPalette.grey.main} !important`,
      fontSize: 16,
      opacity: `0 !important`,
      width: `${spacing(2.8)} !important`,
      transition,
      '&:hover': {
        color: `${colorPalette.grey.dark} !important`,
      },
    },
  };
};

const useStyles = makeStyles(styles);

interface Props {
  enabled: boolean;
  onClick?: (event: any) => void;
  className?: string;
  tooltipMessage: NonNullable<ReactNode>;
  icon: IconProp;
  id: string;
}

export function LoyaltyItemActionButton({
  enabled,
  className,
  onClick = () => null,
  tooltipMessage,
  icon,
  id,
}: Props): React.ReactElement {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Tooltip
      title={
        <>
          {tooltipMessage}
          {enabled ? '' : `: ${t('shared.action.permission.required')}`}
        </>
      }
    >
      <span>
        <IconButton
          disableRipple
          className={clsx(classes.icon, className)}
          onClick={prevent(onClick)}
          disabled={!enabled}
          id={id}
        >
          <FontAwesomeIcon icon={icon} />
        </IconButton>
      </span>
    </Tooltip>
  );
}
